/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroll-component';
import BidsShimmer from "../../bids/bidsShimmer";
import LotSingle from "./Lot";
import NoSearchScreen from "../../../../../CommonComponent/ListingScreens/NoSearchScreen";
import TableHeader from "../../../../../CommonComponent/ListingScreens/TableHeader";
import DeleteLotModal from "../deleteLotModal";

export default function LiveLotTable(props){
    const { 
        lots, loader,
        handleDelete,
        setDeleteLotModal,
        deleteLotModal,
        fetchHandler,
        handleSort, 
        currentSortColumn,
        searchParams,
        searchValue,
        loadLots,
        lotInfo,
        auctionData,
        loading
    } = props;
    const [items, setItems] = useState([]);
    const [limit, setLimit] = useState(10); // Track the current page
    const { id }=useParams();
    const Navigate = useNavigate();
    const [lotNumber,setLotNumber]=useState('')
    const [lotTitle,setLotTitle]=useState('')
    const [lotId, setLotId]=useState('')

    /**
     * The function fetches more data and updates the state with the new items.
     */
    const fetchMoreData = async () => {
        const nexPage = limit + 10
        await fetchHandler(limit);
        setLimit(nexPage);
    };

    useEffect(() => {
        fetchMoreData();
    },[]);

    useEffect(() => {
        if(lots){
            setItems(lots);
        }
    }, [lots])

    const columns = [
        { label: "Lot number", sortKey: "lot_number", testId: "sort-lot-number", minWidth: "130px" },
        { label: "", minWidth: "120px" },
        { label: "Title", sortKey: "title1", testId: "sort-title", minWidth: "170px" },
        { label: "Reserve Price", sortKey: "reserve", testId: "reserve", minWidth: "170px" },
        { label: "Telephone bids", sortKey: "number_of_telephone_bids", testId: "telephone_bids", minWidth: "170px" },
        { label: "Absentee bids", sortKey: "number_of_absentee_bids", testId: "absentee_bids", minWidth: "170px" },
        { label: "", minWidth: "60px" },
    ];
   
    return(
        <div className="md:pb-[70px] pb-[100px] pt-2 overflow-auto mt-4 customScrollbar">
            <div className="z-10 border-[#DEDEDE] border rounded-lg xl:w-full w-fit" 
                style={{transform: "rotateX(180deg)"}}>
                <InfiniteScroll
                    dataLength={items?.length}
                    next={fetchMoreData}
                    hasMore={true}
                    loader={<h4></h4>}
                    className="lots"
                    scrollableTarget="customScroll"
                >
                    <table aria-label="Outside Table" className="w-full overflow-auto table-auto" 
                        style={{transform: "rotateX(-180deg)"}}>
                        <TableHeader currentSortColumn={currentSortColumn} handleSort={handleSort} columns={columns} />
                        <tbody>
                            {(!loadLots && items.length > 0 && !loading ) && (
                                lots.map((lot, index)=><LotSingle
                                    key={index}
                                    lot={lot}
                                    auctionData={auctionData}
                                    setDeleteLotModal={setDeleteLotModal}
                                    setLotNumber={setLotNumber}
                                    setLotTitle={setLotTitle}
                                    setLotId={setLotId}
                                />)
                            )}
                            {(!loading && !loadLots && searchValue !== '' && searchParams.get('search')!==null && items.length==0) &&
                                <NoSearchScreen searchValue={searchValue} cols={7} />}
                            {(!loadLots && !loading && items.length==0 && searchParams.get('search')=== null) && 
                                <tr className="">
                                    <td colSpan="7" className="sm:text-center text-start sm:pl-0 
                                        xs:pl-[200px] pl-[100px]">
                                        <div className="h-[180px] mt-[100px]">
                                            <p
                                                className="text-[18px] font-medium  leading-normal 
                                                        text-[#34343 mb-4"
                                            >
                                                Start adding lots to your auction
                                            </p>
                                            <button 
                                                type="button" 
                                                disabled={(
                                                    auctionData.template_name==='Single Lot' && 
                                                        lotInfo.total_records_found===1
                                                )}
                                                onClick={() => 
                                                    Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/create`, {state: {auction: auctionData}})
                                                }
                                                className="px-[31px] mt-2 py-[12px] bg-[#282828] sm:mx-0 
                                                        mx-3 text-[#FFFFFF] leading-normal font-medium text-[14px] 
                                                        rounded-[6px] disabled:bg-[#D4D4D8] hover:bg-[#3F3F45]
                                                        disabled:text-[hsl(240,4%,65%)]" data-testid="create-lot-button"
                                            >
                                                Create lot
                                            </button>
                                        </div>
                                    </td>
                                </tr>}
                            
                            {(loadLots || loading) &&
                            <BidsShimmer/>}
                        </tbody>
                       
                    </table>
                </InfiniteScroll>
            </div>
            <DeleteLotModal handleDelete={handleDelete} deleteLotModal={deleteLotModal} loader={loader}
                setDeleteLotModal={setDeleteLotModal} lotNumber={lotNumber} lotTitle={lotTitle} parameter={lotId} />
        </div>
    );
}